import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CoachAvatar } from "@/components/CoachAvatar";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/coach" : "/dashboard");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] grain flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 justify-center mb-10" data-testid="auth-logo">
          <CoachAvatar size="sm" />
          <div className="leading-tight text-center">
            <div className="font-serif-display text-xl text-[#1C221D]">India Sadie</div>
            <div className="font-serif-display italic text-xs text-[#5C6A61]">Live the life you've always wanted.</div>
          </div>
        </Link>
        <div className="bg-white rounded-3xl p-8 md:p-10 border border-[#2A3B32]/10 shadow-[0_20px_60px_rgba(42,59,50,0.06)]">
          <h1 className="font-serif-display text-4xl text-[#1C221D]">Welcome back</h1>
          <p className="text-[#5C6A61] mt-2">Pick up where we left off.</p>
          <form onSubmit={onSubmit} className="mt-8 space-y-5">
            <div>
              <label className="eyebrow text-[#5C6A61] block mb-2">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="w-full px-4 py-3 rounded-xl border border-[#2A3B32]/15 bg-[#FDFBF7] focus:outline-none focus:border-[#2A3B32] focus:ring-2 focus:ring-[#81B29A]/30 transition-colors"
              />
            </div>
            <div>
              <label className="eyebrow text-[#5C6A61] block mb-2">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="w-full px-4 py-3 rounded-xl border border-[#2A3B32]/15 bg-[#FDFBF7] focus:outline-none focus:border-[#2A3B32] focus:ring-2 focus:ring-[#81B29A]/30 transition-colors"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full py-3.5 rounded-full bg-[#2A3B32] text-[#FDFBF7] hover:-translate-y-0.5 active:scale-95 transition-transform duration-200 disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <div className="mt-6 text-center text-sm text-[#5C6A61]">
            New here?{" "}
            <Link to="/register" className="text-[#2A3B32] underline underline-offset-4" data-testid="goto-register">
              Create an account
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
